import type { WidenCropKeepArea } from '@hub/libs/constants';
import { WIDEN_DEFAULT_IMAGE_QUALITY } from '@hub/libs/constants';

export class WidenImageConfig {
  // widenKey and name have no default values that make sense, "PREVIEW NOT AVAILABLE" picture is always shown as a fallback
  // width and height can not be set by default because their values should be dependant on one another
  constructor(
    public widenKey: string,
    public name: string,
    public width?: number,
    public height?: number,
    public quality = WIDEN_DEFAULT_IMAGE_QUALITY,
    public animate?: boolean,
    public crop?: boolean,
    public keep?: WidenCropKeepArea,
    public color?: string
  ) {}
}

export type WidenImageConfigKey = keyof WidenImageConfig;
